import React, { useEffect, useState } from "react";
import { Container, Card } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { InputC, ButtonC, InputNumberC } from "./../../../components/simple";
import { MdCopyAll, MdDelete, MdEdit } from "react-icons/md";
import ModalC from "./../../../components/modal";
import { Button, Input, Modal, Pagination, Select, Spin } from "antd";
import CountUp from "react-countup";
import IntlCurrencyInput from "react-intl-currency-input";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { ViewInput } from "../../../GlobalStyles";

const currencyConfig = {
  locale: "pt-BR",
  formats: {
    number: {
      BRL: {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
};

const { confirm } = Modal;

export default function ServicesAdmin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [services, setServices] = useState([]);
  const [servicesTotal, setServicesTotal] = useState(0);
  const [filter, setFilter] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [page, setPage] = useState(0);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [value, setValue] = useState(0);
  const [valueAssociate, setValueAssociate] = useState(0);
  const [commission, setCommission] = useState(0);
  const [min_collaborators, setMin_collaborators] = useState(0);
  const [max_collaborators, setMax_collaborators] = useState(0);
  const [sector, setSector] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    listServices(page, filterSearch);
  }, [page]);

  async function listServices(page, filterSearch) {
    setLoading(true);
    await api
      .get(
        `/services?page=${page}${filterSearch ? `&search=${filterSearch}` : ""}`,
      )
      .then((response) => {
        setServices(response.data.services);
        setServicesTotal(response.data.servicesTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function createAndEditService() {
    if (!name || !value || !commission || !sector) {
      toast.warn("Preencha todos os campos para realizar o cadastro");
    } else {
      if (max_collaborators && min_collaborators) {
        if (max_collaborators < min_collaborators) {
          toast.warn(
            "Número máximo de colaboradores não pode ser maior que o minimo",
          );
          return "";
        }
      }
      if (id) {
        await api
          .put(`/service/${id}`, {
            name,
            description,
            value,
            value_associate: valueAssociate,
            commission,
            sector,
            max_collaborators,
            min_collaborators,
          })
          .then(async (ok) => {
            toast.success("Serviço editado com sucesso");
            listServices(page, filterSearch);
            setVisibleModal(false);
          })
          .catch((response) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      } else {
        await api
          .post(`/service`, {
            name,
            description,
            value,
            value_associate: valueAssociate,
            commission,
            sector,
            max_collaborators,
            min_collaborators,
          })
          .then(async (ok) => {
            toast.success("Serviço criado com sucesso");
            listServices(page, filterSearch);
            setVisibleModal(false);
          })
          .catch((response) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    }
  }

  async function deleteService(id) {
    await api
      .delete(`/service/${id}`)
      .then(() => {
        toast.success("Serviço excluido com sucesso");
        listServices(page, filterSearch);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <h1>Serviços</h1>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={servicesTotal} />
          </Card>
          <div className="filters-row">
            <ViewInput style={{ width: 300 }}>
              <p>Pesquisar</p>
              <Input.Search
                value={filter}
                onChange={(text) => {
                  setFilter(text.target.value);
                }}
                placeholder="pesquisar"
                onSearch={(text) => {
                  setFilterSearch(text);
                  if (page) {
                    setPage(0);
                  } else {
                    listServices(0, text);
                  }
                }}
                allowClear
                onClear={() => {
                  setFilterSearch("");
                  if (page) {
                    setPage(0);
                  } else {
                    listServices(0, "");
                  }
                }}
                enterButton
              />
            </ViewInput>
            <Button
              type="primary"
              style={{
                borderRadius: 50,
                marginBottom: 5,
              }}
              onClick={() => {
                setName("");
                setId("");
                setValue("");
                setValueAssociate("");
                setCommission("");
                setMax_collaborators(0);
                setMin_collaborators(0);
                setSector("");
                setDescription("");
                setVisibleModal(true);
              }}
            >
              Novo Serviço
            </Button>
          </div>
          {services.length == 0 && (
            <h4
              style={{
                marginTop: 50,
                fontWeight: 500,
                width: "100%",
                textAlign: "center",
              }}
            >
              Nenhum serviço encontrado
            </h4>
          )}
          <div className="services">
            {services.map((item) => {
              return (
                <div className="service">
                  <div>
                    <p>
                      {item.name} -{" "}
                      {item.value.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </p>
                    <p style={{ color: "#000a", marginTop: 5 }}>
                      {item.description}{" "}
                    </p>
                    {(!!item.min_collaborators || !!item.max_collaborators) && (
                      <p style={{ color: "#000a", marginTop: 5 }}>
                        {!!item.min_collaborators &&
                          `- Min de colaboradores: ${item.min_collaborators} `}
                        {!!item.max_collaborators &&
                          `- Máx de colaboradores: ${item.max_collaborators}`}
                      </p>
                    )}
                    <p style={{ color: "#0008", marginTop: 5, fontSize: 12 }}>
                      Comissão paga por serviço:{" "}
                      {item.commission.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </p>
                  </div>

                  <Button
                    type="primary"
                    onClick={() => {
                      setId("");
                      setName(item.name);
                      setDescription(item.description);
                      setValue(item.value);
                      setValueAssociate(item.value_associate);
                      setSector(item.sector);
                      setCommission(item.commission);
                      setMax_collaborators(item.max_collaborators);
                      setMin_collaborators(item.min_collaborators);
                      setVisibleModal(true);
                    }}
                  >
                    <MdCopyAll color="#FFF" size={20} />
                    Duplicar
                  </Button>
                  <Button
                    className="warning-button"
                    onClick={() => {
                      setId(item.id);
                      setName(item.name);
                      setDescription(item.description);
                      setValue(item.value);
                      setValueAssociate(item.value_associate);
                      setSector(item.sector);
                      setCommission(item.commission);
                      setMax_collaborators(item.max_collaborators);
                      setMin_collaborators(item.min_collaborators);
                      setVisibleModal(true);
                    }}
                  >
                    <MdEdit color="#FFF" size={20} />
                    Editar
                  </Button>
                  <Button
                    className="delete-button"
                    onClick={() => {
                      confirm({
                        okText: "Confirmar",
                        title: `Deseja excluir o serviço ${item.name}?`,
                        icon: <ExclamationCircleFilled />,
                        content: `Após confirmação, o serviço será excluido`,
                        onOk() {
                          deleteService(item.id);
                        },
                        onCancel() {},
                        cancelText: "Cancelar",
                      });
                    }}
                  >
                    <MdDelete color="#FFF" size={20} />
                    Deletar
                  </Button>
                </div>
              );
            })}
          </div>
          <Pagination
            style={{
              margin: "25px 0",
              alignSelf: "center",
            }}
            defaultCurrent={page + 1}
            pageSize={30}
            onChange={(page) => {
              setPage(page - 1);
            }}
            total={servicesTotal}
          />
        </>
      )}

      <Modal
        title="Serviço"
        width={500}
        open={visibleModal}
        okText={"SALVAR"}
        cancelText="FECHAR"
        onCancel={() => {
          setVisibleModal(false);
        }}
        onOk={() => {
          createAndEditService();
        }}
      >
        <ViewInput>
          <p>Nome</p>
          <Input
            value={name}
            placeholder={"serviço"}
            onChange={(text) => {
              setName(text.target.value);
            }}
          />
        </ViewInput>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <ViewInput style={{ width: "48%" }}>
            <p>Valor</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                color: "#000",
                padding: "6px 8px",
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={value}
              onChange={(event, value) => setValue(value)}
            />
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>Valor para Associado</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                color: "#000",
                padding: "6px 8px",
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={valueAssociate}
              onChange={(event, value) => setValueAssociate(value)}
            />
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>Comisão do Técnico</p>
            <IntlCurrencyInput
              style={{
                width: "100%",
                backgroundColor: "#FFF",
                borderWidth: 0,
                color: "#000",
                padding: "6px 8px",
                fontSize: 14,
                borderWidth: 1,
                borderColor: "#ccc",
                borderStyle: "solid",
                borderRadius: 2,
                fontWeight: "400",
                paddingLeft: 12,
              }}
              currency="BRL"
              config={currencyConfig}
              value={commission}
              onChange={(event, value) => setCommission(value)}
            />
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>Minimo Colaboradores</p>
            <Input
              value={min_collaborators || null}
              placeholder={"minimo"}
              onChange={(text) => {
                setMin_collaborators(parseInt(text.target.value) || 0);
              }}
            />
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>Máximo de Colaboradores</p>
            <Input
              value={max_collaborators || null}
              placeholder={"maximo"}
              onChange={(text) => {
                setMax_collaborators(parseInt(text.target.value) || 0);
              }}
            />
          </ViewInput>
          <ViewInput style={{ width: "48%" }}>
            <p>Setor</p>
            <Select
              value={sector || null}
              style={{
                width: "100%",
                textAlign: "left",
              }}
              onChange={(value) => {
                setSector(value);
              }}
              placeholder="seleciona uma opção"
            >
              <Select.Option value={"Serviços de segurança do Trabalho"}>
                Serviços de segurança do Trabalho
              </Select.Option>
              <Select.Option value={"Revenda de treinamentos online"}>
                Revenda de treinamentos online
              </Select.Option>
              <Select.Option value={"Serviços Medicina ocupacional"}>
                Serviços Medicina ocupacional
              </Select.Option>
              <Select.Option value={"Credenciamento SST"}>
                Credenciamento SST
              </Select.Option>
              <Select.Option value={"Assinatura Documentos SST"}>
                Assinatura Documentos SST
              </Select.Option>
            </Select>
          </ViewInput>
        </div>
        <ViewInput>
          <p>Descrição</p>
          <Input.TextArea
            value={description}
            style={{
              minHeight: 80,
            }}
            placeholder={"descrição detalhada sobre o Serviço"}
            onChange={(text) => {
              setDescription(text.target.value);
            }}
          />
        </ViewInput>
      </Modal>
    </Container>
  );
}
